// extracted by mini-css-extract-plugin
module.exports = {"el":"Form-module__el___37hHA","label":"Form-module__label___34qhf","input":"Form-module__input___1xU1l","error":"Form-module__error___-FdWI Fonts-module__at___1f_7n"};